import type {
  RenderFunction,
  IActivityFeedData,
} from '@sennder/microfrontend-registry/ActivityFeed'

import { getMfContext } from '@/router/routes'
import { getStateData, getStoreLegacyFlags } from '@/store'
import { watch } from 'vue'
import {
  getFunction,
  MFRepositories,
  Repositories,
} from '@sennder/microfrontend-registry'

const NPM_NAME = Repositories[MFRepositories.ActivityFeed].meta.fml.npmName

const getFml = async () => {
  const fn = await getFunction(MFRepositories.ActivityFeed, 'RemoteFunctions', {
    integrator: 'SennTMS',
  })

  return fn.default
}

let onSharedDataChanged: ((data: IActivityFeedData) => void) | undefined

const getActivityFeedData = () => getMfContext(NPM_NAME)

export const initActivityFeedProvider = async () => {
  const updateSharedData = async () => {
    const sharedData = await getActivityFeedData()

    onSharedDataChanged?.({
      language: sharedData.data.profile.language,
      user: {
        fullNameWithoutTitle: sharedData.data.profile.name,
        uuid: sharedData.data.profile.id,
      },
      profile: sharedData.data.profile,
      featureFlags: sharedData.data.featureFlags,
    })
  }

  watch([() => getStateData().language, getStoreLegacyFlags], updateSharedData)

  // Function called when feed should be rendered
  const renderActivityFeed: RenderFunction = async (root, conf) => {
    const fml = await getFml()

    const mfContext = await getMfContext(NPM_NAME)

    const {
      data: { profile },
    } = mfContext

    if (!profile) {
      throw new Error('state.data.profile is not initialized')
    }

    const mountFns = fml.mountActivityFeed(
      root,
      {
        ...mfContext,
        data: {
          ...mfContext.data,
          profile,
          user: {
            fullNameWithoutTitle: profile.name,
            uuid: profile.id,
          },
        },
      },
      conf
    )
    onSharedDataChanged = mountFns.onSharedDataChanged

    return mountFns
  }

  window.renderActivityFeed = renderActivityFeed
}
